<!-- Fancy tooltip -->
<span
  *ngIf="tooltip"
  class="form-icon-fancy">

  <!-- Content -->
  <popper-content
    #popperContent>
    <div
      [innerHtml]="tooltip">
    </div>
  </popper-content>

  <!-- help button -->
  <mat-icon
    tabindex="-1"
    [popper]="popperContent"
    popperTrigger="hover"
    popperApplyClass="gd-form-input-v2-tooltip"
    popperPreventOverflow="true"
    popperPositionFixed="true"
    popperAppendTo="body"
    (click)="$event.stopPropagation()">help</mat-icon>
</span>
